import { Component } from '@theme/component';

export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement'];

  connectedCallback() {
    super.connectedCallback();

    if (this.hasAttribute('data-desktop-only')) {
      this.desktopMediaQuery = window.matchMedia('(min-width: 750px)');

      if (!this.desktopMediaQuery.matches) {
        this.desktopMediaQuery.addEventListener('change', this.handleDesktopMediaChange);
        return;
      }
    }

    this.loadVideo();
  }

  disconnectedCallback() {
    this.desktopMediaQuery?.removeEventListener('change', this.handleDesktopMediaChange);
    super.disconnectedCallback();
  }

  handleDesktopMediaChange = (event) => {
    if (!event.matches) return;

    this.loadVideo();
    this.desktopMediaQuery.removeEventListener('change', this.handleDesktopMediaChange);
  };

  loadVideo() {
    if (this.videoLoaded) return;

    const { videoSources, videoElement } = this.refs;

    for (const source of videoSources) {
      const { videoSource } = source.dataset;

      if (videoSource) source.setAttribute('src', videoSource);
    }

    videoElement.load();
    this.videoLoaded = true;
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}
